export const currentCallbackUrl = () => `${process.env.BASE_URL}${useRoute().fullPath}`

export default defineNuxtPlugin((nuxtApp) => {
  return {
      provide: {
        currentCallbackUrl
      }
  }
})

